export default __webpack_public_path__ + "static/media/contact.466e04d3.png";